<template>
  <div class="table-responsive ms-5 me-5">
    <table class="table">
      <tbody>
        <tr>
          <th>Material</th>
          <th>Especificación</th>
          <th>Presentación</th>
          <th>Nombre</th>
          <th>Precio</th>
        </tr>
        <tr v-for="tube in tubes" :key="tube.id">
          <td>{{ tube.material }}</td>
          <td>{{ tube.specification }}</td>
          <td>{{ tube.presentation }}</td>
          <td>{{ tube.name }}</td>
          <td>{{ tube.priceId["value"] }}</td>
          <td>
            <div>
              <button class="btn btn-danger" @click.prevent="viewTubeTypes(tube.id, tube.name, tube.specification)">
                Visualizar
              </button>
            </div>
          </td>
          <td>
            <div>
              <button class="btn btn-danger" @click.prevent="editTube(tube.id)">
                Editar
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  data() {
    return {
      tubes: [],
    };
  },
  methods: {
    viewTubeTypes(tubeId, tubeName, tubeSpecification) {
      this.$emit("sendMainTubeIdForTypes", { tubeId, tubeName, tubeSpecification });
    },
    editTube(tubeId) {
      this.$emit("sendMainTubeIdForEdit", tubeId);
    },
  },
  beforeMount() {
    axios
      .get(RUTA_SERVIDOR + "api/tube/list", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => (this.tubes = res.data))
      //   .then((res) => console.log(this.tubes))
      .catch((err) => console.log(`There has been an error ${err}`));
  },
};
</script>
<style scoped></style>